<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/z2ZWLC/tc-custom/9780830864645.jpg?1684515367872?1696025454752" alt="This image is the cover for the book A Guidebook to Prayer"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">A Guidebook to Prayer
      </h1>
      <p class="bookDescription body article font2">
        <p>Why is prayer so hard? Many of us have asked that question. We want to pray. We intend to pray. But, as spiritual director and professor MaryKate Morse notes, " we don't pray as consistently or as meaningfully as we might like." And yet prayer offers us such spiritual riches. Prayer</p>  draws us to experience love and to be love increases our faith expands our vision of God helps us grow in self-understanding gives us perspective on life and death  <p>Morse continues: "Through prayer, we experience forgiveness, guidance and peace. We are healed physically and emotionally. We experience the mystery of God, see truth and receive spiritual gifts. We receive vision and courage for God's mission. Faith becomes more beautiful, more real." This guidebook is designed to move you from lamenting over prayerlessness to the joy of praying. Whether you are a beginner or a lifetime person of faith, you will find a treasure trove of riches here to guide you into a deeper experience of prayer. Each chapter explores a different angle of prayer with sections focusing on each of the persons of the Trinity—Father, Son and Holy Spirit. And each chapter offers specific ways to pray both on your own, with a partner or in a group. Sprinkled throughout are reflections from the author's former students describing on their own experience with these practices. A treasure trove of both resources and encouragement, you will find this book to be an indispensable guide to your life of prayer.</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        MaryKate Morse, Joshua Choonmin Kang
      </h2>
      
      <p class="authorDescription body article"><p>MaryKate Morse is professor of leadership and spiritual formation at George Fox Evangelical Seminary in Portland, Oregon. She is the author of <em>Making Room for Leadership.</em> She holds an M.A. in biblical studies and an M.Div. from Western Evangelical Seminary (now George Fox Evangelical Seminary), and her doctorate in leadership from Gonzaga University. In addition to teaching she also serves as a consultant to churches and organizations in transition or with leadership challenges. She has planted two churches with leadership teams in Portland, Oregon. Along with being a Quaker minister and a trained spiritual director, she also does conference and retreat ministries and mentors leaders.</p></p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      InterVarsity Press
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?57e416b2